import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { AiFillEdit } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const FieldsTable = ({ setEditMode, onDelete, rows }) => {
  const selector = useSelector((state) => state.business);

  const columnDefs = useMemo(() => [
    {
      field: 'label',
      headerName: 'Field Name',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'datatype',
      headerName: 'Field Type',
      flex: 1,
      minWidth: 120,
      valueFormatter: (params) => {
        const type = params.value || '';
        return ({ VARCHAR: 'Text', FLOAT: 'Number', INT: 'Number', DATE: 'Date', TIME: 'Time' })[type] || type;
      },
    },
    {
      field: 'is_required',
      headerName: 'Required',
      width: 110,
      valueFormatter: (params) => (params.value === 1 ? 'Yes' : 'No'),
    },
    {
      field: 'values',
      headerName: 'Options',
      flex: 1,
      minWidth: 120,
      valueFormatter: (params) => params.value || '—',
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      cellRenderer: (params) => (
        <span className="flex gap-4 justify-center items-center h-full">
          <AiFillEdit
            className="cursor-pointer"
            onClick={() => setEditMode(params.data)}
          />
          <MdDelete
            color="red"
            className="cursor-pointer"
            onClick={() => onDelete?.(params.data.field_id)}
          />
        </span>
      ),
      sortable: false,
      filter: false,
    },
  ], [setEditMode, onDelete]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    filter: true,
    resizable: true,
  }), []);

  return (
    <div className="ag-theme-alpine" style={{ height: '500px', width: '100%', padding: '16px' }}>
      <AgGridReact
        rowData={rows || selector?.fields || []}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        pagination={true}
        paginationPageSize={10}
        animateRows={true}
        getRowId={(params) => String(params.data.field_id)}
      />
    </div>
  );
};

export default FieldsTable;
